import React from 'react';
import { useState } from "react";
import Card from 'react-bootstrap/Card';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { TData } from '../helpers/TenantData';


const Tenant = () => {
    const [tenant, setTenant] = useState("Select one");
    const [confGenerated,setConfGenerated] = useState("");
    const [domain,setDomain] = useState("");


    const handleSelect = (o) => {
  
        setTenant(o.label);

        let full = window.location.protocol + '//' + window.location.hostname + ':' +  window.location.port + "?ovveride=true&cfg=";
            
        let jsObject = {
            "background" : "url(" + o.image + ")",
            "language": (o.voice === 1 ? 'it-IT':'en-US'),
            "tenant" : o.uid,
            "inputbox": false,
            "notifier" : false,
        }


        let encodedObject = window.btoa(JSON.stringify(jsObject));

        setConfGenerated(encodedObject);
        setDomain(full);



      };

    return (
        <div>

            <Card className="center-card" style={{ width: '28rem' }}>
                <Card.Img style={{ padding: '15px' }} variant="top" src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
                <Card.Body>
                    <Card.Title>Select Tenant:</Card.Title>

                    <DropdownButton id="dropdown-basic-button" variant="secondary" title={tenant}>

                        {TData.map(option => (
                            <Dropdown.Item key={option.uid} onClick={() => handleSelect(option)}>
                                {option.label}
                            </Dropdown.Item>
                        ))}
                    </DropdownButton>

                </Card.Body>
            </Card>


            <Card className="center-card" style={{ width: '28rem' }}>
            <Card.Body>
            <Card.Title>Configuration</Card.Title>
            <a href={'/?override=true&cfg=' + confGenerated}>{domain}{confGenerated}</a>
            </Card.Body>  
            </Card>

        </div>
    );


};

export default Tenant;